import { useTranslation } from "react-i18next";

export const namespaces = ["common", "locale", "role", "permission", "menu", "user", "groupUser", "library", "config", "status", "workflow", "step", "form", "module", "layout", "page", "profile", "login"] as const;

type Namespace = typeof namespaces[number];
type TypeT = (code: string, data: { ns: Namespace }) => string;
interface UseAppTranslationProps { t: TypeT }
const useAppTranslation = (): UseAppTranslationProps => {
    const { t } = useTranslation(namespaces);
    return { t };
}

export default useAppTranslation;